module.exports = __webpack_public_path__ + "img/schedule-test-drive-button.54d7881f.png";